import React from 'react';

const BuySellToken = ({type}) => {
	return (
		<div style={{display: "inline-block", borderRadius: 5, color: "#fff", padding: "2px 5px", backgroundColor: type.toLowerCase() === "sell" ? "#E35953" : "#30C9AC", textTransform: "capitalize"}}>{type}</div>
   );
}

export default BuySellToken;